
import React, { useState } from 'react';
import { Typography, Button, TextField, List, ListItem, ListItemText, Divider, Checkbox, FormControlLabel, ListItemIcon, MenuItem } from '@mui/material';
import SignalWifi0BarIcon from '@mui/icons-material/SignalWifi0Bar';
import LockIcon from '@mui/icons-material/Lock';
import Wifi1Bar from '@mui/icons-material/Wifi1Bar';
import Wifi2Bar from '@mui/icons-material/Wifi2Bar';
import WifiIcon from '@mui/icons-material/Wifi';

export default function WifiSetup({ handleNext, handleBack, wifiList, wifiSsid, setWifiSsid, wifiPassword, setWifiPassword, isConnected, handleRestart }) {
  const [manualEntry, setManualEntry] = useState(false);
  const [isPasswordNeeded, setIsPasswordNeeded] = useState(true)
  const [isShowPassword, setIsShowPassword] = useState(false);

  const jsonWifiEnum = {
    SSID: 0,
    RSSI: 1,
    ENCRYPTION_TYPE: 2,
  }

  const handleWifiSelect = (wifi) => {
    setWifiSsid(wifi[0]);
    setIsPasswordNeeded(wifi[2] !== 0)
    setWifiPassword('');  // Clear password field on selection
  };

  const isNextDisabled = (manualEntry ? !wifiSsid : !wifiSsid || (isPasswordNeeded ? wifiPassword === '' : false))

  return (
    <div>
      <Typography variant="h6" gutterBottom style={{ textAlign: 'center' }}>
        Wi-Fi 설정
      </Typography>
      <br />
      {!manualEntry ? (
        <div>
          <Typography variant="body1" gutterBottom>
            네트워크 목록에서 선택하거나 직접 입력해서 연결:
          </Typography>
          <List>
            {wifiList.map((wifi, index) => (
              <MenuItem button key={index} onClick={() => handleWifiSelect(wifi)} selected={wifiSsid === wifi[0]} style={{ borderRadius: 5, padding: '8px' }}>
                <ListItemText primary={wifi[jsonWifiEnum.SSID]} />
                {wifi[jsonWifiEnum.ENCRYPTION_TYPE] > 0 &&
                  <ListItemIcon>
                    <LockIcon edge='end'/>
                  </ListItemIcon>
                }
                {wifi[jsonWifiEnum.RSSI] < -85 && 
                  <ListItemIcon>
                    <SignalWifi0BarIcon edge='end'/>
                  </ListItemIcon>
                }
                {wifi[jsonWifiEnum.RSSI] >= -85 && wifi[jsonWifiEnum.RSSI] < -70 && 
                  <ListItemIcon>
                    <Wifi1Bar edge='end'/>
                  </ListItemIcon>
                }
                {wifi[jsonWifiEnum.RSSI] >= -70 && wifi[jsonWifiEnum.RSSI] < -50 && 
                  <ListItemIcon>
                    <Wifi2Bar edge='end'/>
                  </ListItemIcon>
                }
                {wifi[jsonWifiEnum.RSSI] >= -50 && 
                  <ListItemIcon>
                    <WifiIcon edge='end'/>
                  </ListItemIcon>
                }
              </MenuItem>
            ))}
          </List>
          {wifiSsid && (
            <>
              <Divider style={{ margin: '12px 0 12px 0' }} />
              <Typography variant="h6" gutterBottom>
                {wifiSsid} 에 연결하기
              </Typography>
              {isPasswordNeeded && (
              <>
                <TextField
                  label="Password"
                  variant="outlined"
                  fullWidth
                  type={isShowPassword?"text":"password"}
                  value={wifiPassword}
                  onChange={(e) => setWifiPassword(e.target.value)}
                  style={{ marginBottom: '16px' }}
                />
                <FormControlLabel control={
                  <Checkbox
                    checked={isShowPassword}
                    onChange={(e) => setIsShowPassword(e.target.checked)}
                  />
                  }
                  label="비밀번호 보기"
                />
              </>
              )}
            </>
          )}
        </div>
      ) : (
        <div>
          <TextField
            label="SSID"
            variant="outlined"
            fullWidth
            value={wifiSsid}
            onChange={(e) => setWifiSsid(e.target.value)}
            style={{ marginBottom: '16px' }}
          />
          <TextField
            label="Password"
            variant="outlined"
            fullWidth
            type={isShowPassword?"text":"password"}
            value={wifiPassword}
            onChange={(e) => setWifiPassword(e.target.value)}
            style={{ marginBottom: '16px' }}
          />
          <FormControlLabel control={
            <Checkbox
              checked={isShowPassword}
              onChange={(e) => setIsShowPassword(e.target.checked)}
            />
            }
            label="비밀번호 보기"
          />
        </div>
      )}
      <Divider style={{ margin: '12px 0 12px 0' }} />
      { isConnected ? (
        <>
          {!manualEntry ? (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setManualEntry(true)}
              style={{ float: 'left' }}
            >
              직접 입력
            </Button>
          ) : (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setManualEntry(false)}
              style={{ float: 'left' }}
            >
              WiFi 검색 목록에서 선택
            </Button>
          )}
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            disabled={isNextDisabled}
            style={{ float: 'right' }}
          >
            다음
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleBack}
            style={{ float: 'right', margin: '0 8px' }}
          >
            이전
          </Button>
        </>
      ) : (
        <Button
          variant="contained"
          color="secondary"
          onClick={handleRestart}
          style={{ float: 'right', margin: '0 8px' }}
        >
          처음으로
        </Button>
      )}
    </div>
  );
}
